import React, { useState, useEffect } from 'react';
import { Empty, message, Table, Card, Spin, Row, Col, Skeleton } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from "react-router-dom"
import { generateDynamicColumns, generateUsersTableData } from '../Pages/AllTableColumns/LeadTable';
import { useExcryptedNavigation } from '../Filters/FilterConditions';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { StaffIcon, AccountsIcon } from '../../../components/Icons/Icons';
import { FetchDealByEntity } from "../../../Api/Services/CommonApiService"; // getColumnConfigs, 
import LeadColumnFields from '../CustomColumn/LeadColumns.json'
import LeadColumns from '../Popup/ManageColumn'

const LeadTable = ({ UrlId, listingType, listingValues, setSelectedKeys, queryAction, refreshTrigger, tabKey }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [leads, setLeads] = useState()
    const [customopen, setCustomopen] = useState(false)
    const [checkboxValues] = useState(LeadColumnFields.Columns) // setCheckboxValues
    const [configId] = useState() // setConfigId
    const [sortedInfo, setSortedInfo] = useState()
    const leadtype = "LEAD"
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);
        // const rawTime = converted.format("HH:mm");
        // const formattedTime = convertTime(rawTime, profile?.timeFormat);

        return formattedDate
    }
    const { ExcryptedNavigation } = useExcryptedNavigation()
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const ViewDetailPage2 = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    async function AllLeads(type, id) {
        try {
            if (type === "Task") {
                const response = await FetchDealByEntity(id, "Lead")
                const SortedData = response.sort((a, b) => b.leads_id - a.leads_id);
                const dataWithCurrency = await Promise.all(
                    SortedData.map(async item => {
                        return {
                            ...item,
                            DataPermission: { isPresent: item.allow }

                        };
                    })
                );
                setLeads(dataWithCurrency);
            }
        } catch (error) {
            message.error(error);
        }
    }
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setStates({ ...states, selectedRowKeys, selectedRows });
            setSelectedKeys(selectedRowKeys)
        },
        getCheckboxProps: (record) => {
            const permission = record.SharingData
            if (record?.LeadDataForPermission?.approved_for !== "None") {
                return { disabled: true };
            }
            // Outreach: only leads owned by the logged-in user can be selected
            if (queryAction === "Outreach") {
                return { disabled: record?.LeadDataForPermission?.lead_owner !== profile.userId };
            }

            // Only apply permission checks for these actions
            if (["Update", "OwnerChange", "Delete", "Sharing"].includes(queryAction)) {
                if (!permission) return { disabled: false }; // Full access if no sharingPermission

                if (["Update", "OwnerChange"].includes(queryAction)) {
                    return { disabled: !permission.includes("Update") };
                }

                if (queryAction === "Delete") {
                    return { disabled: !permission.includes("Delete") };
                }

                if (queryAction === "Sharing") {
                    return { disabled: !permission.includes("Sharing") };
                }
            }
            return { disabled: false };
        }

        // selectedRowKeys: states.selectedRowKeys,
        // onChange: (selectedRowKeys) => {
        //     // Update selected keys when a change occurs
        //     setStates({
        //         ...states,
        //         selectedRowKeys, // Set the selected row keys for rows across all pages
        //     });
        //     setSelectedKeys(selectedRowKeys);
        // },
        // onSelect: (record, selected) => {
        //     if (selected) {
        //         // Add selected row to the state if selected
        //         setStates({
        //             ...states,
        //             selectedRows: [...states.selectedRows, record],
        //             selectedRowKeys: [...states.selectedRowKeys, record.key],
        //         });
        //     } else {
        //         // Remove unselected row from the state
        //         setStates({
        //             ...states,
        //             selectedRows: states.selectedRows.filter(row => row.key !== record.key),
        //             selectedRowKeys: states.selectedRowKeys.filter(key => key !== record.key),
        //         });
        //     }
        // },
        // onSelectAll: (selected) => {
        //     if (selected) {
        //         // Select all rows across the entire dataset, not just the current page
        //         const allRowKeys = LeadTableData.map(item => item.key); // Get keys of all rows in the dataSource
        //         setStates({
        //             ...states,
        //             selectedRowKeys: allRowKeys,  // Select all keys from the entire dataset
        //             selectedRows: LeadTableData,  // Select all rows from the entire dataset
        //         });
        //     } else {
        //         // Deselect all rows across all pages
        //         setStates({
        //             ...states,
        //             selectedRowKeys: [],  // Clear selection
        //             selectedRows: [],  // Clear selected rows
        //         });
        //     }
        // },
    };
    async function getColumnConfig() {
        try {
            // const data = await getColumnConfigs("LeadTable");
            // if (data === "") {
            //     setCheckboxValues(LeadColumnFields.Columns)
            //     setConfigId()
            // } else {
            //     setCheckboxValues(data.c_config)
            //     setConfigId(data.c_data_config_id)
            // }
        } catch (error) {
            message.error(error);
        }
    }
    const handleTableChange = async (_, _1, sorter) => {
        setSortedInfo(sorter)
    }
    const dynamicColumns = generateDynamicColumns(checkboxValues, ViewDetailPage, sortedInfo);
    const usersTableData = generateUsersTableData(leads);
    useEffect(() => {
        if (listingType === "Query") {
            const SortedData = listingValues.sort((a, b) => b.leads_id - a.leads_id);
            const transformedData = SortedData.map(item => ({
                ...item,
                created_at: item.created_at ? convertAndFormatDateTime(item.created_time ? `${item.created_at} ${item.created_time}` : item.created_at, companyProfile, profile) : "",
                modified_at: item.modified_at ? convertAndFormatDateTime(item.modified_time ? `${item.modified_at} ${item.modified_time}` : item.modified_at, companyProfile, profile) : "",
            }));

            setLeads(transformedData)
        }
    }, [listingType, listingValues])
    useEffect(() => {
        if (listingType !== "Query") {
            if (refreshTrigger === tabKey) {
                if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
                    AllLeads("Lead", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                    AllLeads("Deal", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
                    AllLeads("Contact", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
                    AllLeads("Account", UrlId[1])
                }
                else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK") {
                    AllLeads("Task", UrlId[1])
                }
                getColumnConfig();
            }
        }
    }, [UrlId, refreshTrigger, tabKey])
    const TableSkeleton = () => {
        const skeletonRowStyle = {
            padding: '13px 20px',
            height: '68px',
            borderBottom: '1px solid #f0f0f0',
        };
        return (
            <div>
                {Array.from({ length: 5 }).map((_, idx) => (
                    <div key={idx} style={skeletonRowStyle}>
                        <Skeleton
                            avatar paragraph={{ rows: 2, width: '100%' }}
                            active
                            title={false}
                        />
                    </div>
                ))}
            </div>
        );
    }; const LoadingCiolums = [
        {
            title: (
                <Skeleton
                    paragraph={{ rows: 1, width: '100%' }}
                    active
                    title={false}
                />
            ),
            dataIndex: 'name',
            key: 'name',
        },]
    return (
        <>
            {listingType === "Query" ?
                // <div className="full-width-table" style={{ width: "100%" }} >
                <div className='Listing-PagePadding' style={{ width: "100%" }}>
                    <Cards headless bodyStyle={{ borderRadius: '10px' }}>
                        <div className="table-bordered leaderboard-table table-responsive">
                            <Table
                                showSorterTooltip={false}
                                rowSelection={rowSelection}
                                dataSource={usersTableData}
                                columns={!leads ? LoadingCiolums : dynamicColumns}
                                locale={{
                                    emptyText: !leads ? (
                                        <TableSkeleton rows={5} />
                                    ) :
                                        leads?.length === 0 && <Empty />
                                }}
                                onChange={handleTableChange}
                                pagination={{
                                    defaultPageSize: 5,
                                    total: usersTableData.length,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                }} />
                        </div>
                    </Cards>
                </div>
                :
                <Row gutter={30}>
                    {leads ? (leads?.length > 0 ?
                        leads?.map((item, index) => {
                            return (
                                <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    <div key={index} style={{ marginBottom: 15 }}
                                        className={item.DataPermission.isPresent ? "Card-click" : "Card-disabled"}
                                        role="button"
                                        tabIndex={0}
                                        onClick={item.DataPermission.isPresent ? () => ViewDetailPage2(item?.leads_id, leadtype) : undefined}
                                        onKeyDown={(event) => {
                                            if (item.DataPermission.isPresent && (event.key === 'Enter' || event.key === ' ')) {
                                                ViewDetailPage2(item?.leads_id, leadtype)
                                            }
                                        }}
                                        aria-label='phone'
                                    >
                                        <Card className="DetailsTabCard">
                                            <div style={{ padding: 10 }}>
                                                <div className='user-info_image' style={{ marginBottom: 5, display: "flex", alignItems: "center", minWidth: 0, }}
                                                > {item?.lead_profile !== null && item?.lead_profile
                                                    !== undefined && item?.lead_profile !== "" ?
                                                    <figure>
                                                        <img style={{ width: "30px", height: "30px", objectFit: "cover", flexShrink: 0 }} src={item?.lead_profile} alt="" />
                                                    </figure>
                                                    :
                                                    <span className='list_span_Tag ContactIcon' style={{ flexShrink: 0, }}>
                                                        {item?.first_name?.slice(0, 1).toUpperCase()}
                                                    </span>
                                                    }
                                                    <figcaption style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        overflow: "hidden", // 👈 keeps ellipsis responsive
                                                    }}> <div style={{
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }} title={`${item?.first_name} ${item?.last_name}`}>
                                                            {`${item?.first_name} ${item?.last_name}`}
                                                        </div>
                                                        <div style={{
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }} title={item?.primary_email} className='entityemail'>
                                                            {item?.primary_email}
                                                        </div>
                                                    </figcaption>
                                                </div>
                                                <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                    <StaffIcon height={15} width={15} marginRight={5} />{item?.designation}
                                                </div>
                                                <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                    <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />
                                                    {(item?.mobile && item?.mobile !== "") ? item?.mobile : <span style={{ visibility: "hidden" }}>0</span>}
                                                </div>
                                                <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
                                                    <AccountsIcon height={15} width={15} marginRight={5} />{item?.account_name}
                                                </div>
                                            </div>
                                        </Card>
                                    </div >
                                </Col >
                            )
                        }) :
                        <div style={{ padding: "10%" }}>
                            <Empty />
                        </div>)
                        :
                        <div className="spin">
                            <Spin />
                        </div>
                    }
                </Row >
            }
            {customopen && <LeadColumns customopen={customopen} setCustomopen={setCustomopen} checkboxValues={checkboxValues} configId={configId} getColumnConfig={getColumnConfig} pageName="LeadTable" />}
        </>
    );
}
LeadTable.propTypes = {
    listingType: PropTypes.string.isRequired,
    queryAction: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    listingValues: PropTypes.array.isRequired,
    setSelectedKeys: PropTypes.func.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(LeadTable)